import {
  ApiAttributionModel,
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { Grid } from "@mui/material";
import { AnalyticsSpacing } from "consts";
import {
  AttributionHeader,
  metricsByAttributionModelType,
  table10Rows,
} from "features/analytics";
import withPaidChannelAttributes from "HoC/withPaidChannelAttributes";
import { useMemo } from "react";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import {
  CHART_KEY_ECOM_INSIGHTS_PAID_CAMPAIGNS_LANDING_PAGES_TABLE,
  CHART_KEY_ECOM_INSIGHTS_PAID_CAMPAIGNS_TABLE,
  CHART_KEY_ATTRIBUTION_HEADER_TOP_BY_TREND,
} from "features/analytics/constants/chartKeys";

function PaidCampaignInsights({ paidChannelAttributes }) {
  const attrMetrics = useMemo(() => {
    return metricsByAttributionModelType(ApiAttributionModel.NO_MODEL_SELECTED);
  }, []);

  return (
    <Grid container spacing={AnalyticsSpacing} mb={4}>
      <Grid item xs={12}>
        <AttributionHeader
          chartKey={`${CHART_KEY_ATTRIBUTION_HEADER_TOP_BY_TREND}_ecom_paid_campaigns`}
          dimension={ApiDimension.DIMENSION_CAMPAIGN}
          title={"Paid Campaigns"}
          attributes={paidChannelAttributes}
        />
      </Grid>
      <Grid item xs={12} sx={{ minHeight: table10Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_ECOM_INSIGHTS_PAID_CAMPAIGNS_TABLE}
          chart={{
            name: "",
            dimension: [ApiDimension.DIMENSION_CAMPAIGN],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: paidChannelAttributes,
            comparison: true,
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_AVERAGE_PAGEVIEWS_PER_SESSION,
                  ApiMetric.METRIC_SESSION_ADD_TO_CART_CLICK_RATE,
                  ...attrMetrics,
                  ApiMetric.METRIC_CPA,
                  ApiMetric.METRIC_VISIT_TO_PURCHASE_RATE,
                  ApiMetric.METRIC_CPNV,
                ],
              },
            ],
            displayOptions: {
              noTitle: true,
              rowsPerPage: 0,
              noFilters: true,
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sx={{ minHeight: table10Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_ECOM_INSIGHTS_PAID_CAMPAIGNS_LANDING_PAGES_TABLE}
          chart={{
            name: "",
            dimension: [
              ApiDimension.DIMENSION_CAMPAIGN,
              ApiDimension.DIMENSION_DOMAIN,
              ApiDimension.DIMENSION_LANDING_PAGE_PATH,
            ],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: paidChannelAttributes,
            includePublisherReadyOnly: true,
            comparison: true,
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_SESSION_ADD_TO_CART_CLICK_COUNT,
                  ApiMetric.METRIC_SESSION_ADD_TO_CART_CLICK_RATE,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_AVERAGE_PAGEVIEWS_PER_SESSION,
                  ...attrMetrics,
                  ApiMetric.METRIC_CPA,
                  ApiMetric.METRIC_VISIT_TO_PURCHASE_RATE,
                  ApiMetric.METRIC_CPNV,
                ],
              },
            ],
            displayOptions: {
              noTitle: true,
              rowsPerPage: 0,
              noFilters: true,
            },
          }}
        />
      </Grid>
    </Grid>
  );
}

export default withPaidChannelAttributes(PaidCampaignInsights);
